"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;
var _Footer = require("./Footer.styles");
var _Button = require("../../../Button");
var _hooks = require("../../../../hooks");
var _Menu = require("../../Menu.labels");
var _jsxRuntime = require("react/jsx-runtime");
var Footer = function Footer(props) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var onConfirm = props.onConfirm,
    onCancel = props.onCancel;
  var styles = (0, _Footer.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _Menu.labels
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Menu__footer'],
    children: [!isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      id: "ccMenuFooterCancel",
      view: "link",
      color: "primary",
      size: "small",
      onClick: onCancel,
      children: getLabel('cancel')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      id: "ccMenuFooterConfirm",
      view: "contained",
      color: "primary",
      size: isMobileView ? 'stretch' : 'small',
      shape: isMobileView ? 'rectangle' : 'ellipse',
      onClick: onConfirm,
      children: getLabel('confirm')
    })]
  });
};
exports.Footer = Footer;